<div class="dialog" fxLayout="column">

  <div mat-dialog-header>
    <div class="dialog-title" fxLayout="row" fxLayoutAlign="space-between end">
      <div fxLayout="row" fxLayoutGap="10px">
        <mat-icon>search</mat-icon>
        <h1>{{'日次入退場状況：検索条件' | translate}}</h1>
      </div>

      <div fxLayout="row" fxLayoutGap="10px">
        <button mat-raised-button color="primary" (click)="search()">
          <mat-icon>search</mat-icon>
          <span>{{'検索' | translate}}</span>
        </button>
        <button mat-button (click)="onNoClick()">
          <mat-icon>clear</mat-icon>
        </button>
      </div>
    </div>
  </div>
  <div mat-dialog-content [formGroup]="editForm">
    <div class="dialog-body" fxLayout="column" fxLayoutGap="24px">

      <mat-form-field floatLabel="always">
        <mat-label>{{'イベント' | translate}}</mat-label>
        <mat-select placeholder="{{'イベント' | translate}}" formControlName="entrance_exit_event_id">
          <mat-option [value]=""></mat-option>
          <mat-option *ngFor="let event of events" [value]="event.id">
            {{ event.names[0].name }} ({{ event.open_start_date.seconds * 1000 | date: 'yyyy/MM/dd' }} - {{ event.open_end_date.seconds * 1000 | date: 'yyyy/MM/dd' }})
          </mat-option>
        </mat-select>
      </mat-form-field>


      <mat-form-field floatLabel="always">
        <mat-label>{{'来場日：開始日 - 終了日' | translate}}</mat-label>
        <mat-date-range-input [rangePicker]="pickerEvent">
          <input matStartDate formControlName="start_date" placeholder="{{'開始日' | translate}}" readonly>
          <input matEndDate formControlName="end_date" placeholder="{{'終了日' | translate}}" readonly>
        </mat-date-range-input>
        <button mat-button matSuffix aria-label="Clear" (click)="clearDate()">
          <mat-icon>close</mat-icon>
        </button>
        <mat-datepicker-toggle matSuffix [for]="pickerEvent"></mat-datepicker-toggle>
        <mat-date-range-picker #pickerEvent></mat-date-range-picker>
      </mat-form-field>
    </div>
  </div>
</div>

